import { render } from "./AgregarTercero.vue?vue&type=template&id=252884bc&ts=true"
import script from "./AgregarTercero.vue?vue&type=script&lang=ts"
export * from "./AgregarTercero.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__